exports.standardSchemas = {
  pageload: {
    dataLayer: {
      type: 'object',
      properties: {
        page: {
          type: 'object',
          properties: {
            locale: {
              type: 'object',
              properties: {
                country: { type: 'string' },
                currency: { type: 'string' },
                language: { type: 'string' },
              },
            },
            pageInfo: {
              type: 'object',
            },
          },
        },
      },
    },
  },
  addtobasketsuccess: {
    payload: {
      type: 'object',
      properties: {
        action: { type: 'string' },
        type: { type: 'string' },
        buttonType: { type: 'string' },
        qtyRequested: { type: 'number' },
        product: {
          type: 'object',
          properties: {
            itemPrice: { type: 'number' },
            productId: { type: 'string' },
            qty: { type: 'integer' },
            services: { type: 'array' },
            sku: { type: 'string' },
          },
        },
      },
    },
    dataLayer: {
      type: 'object',
      properties: {
        basket: {
          type: 'object',
          properties: {
            itemPrice: {
              type: 'object',
              properties: {
                itemPrice: { type: 'number' },
                productId: { type: 'string' },
                qty: { type: 'integer' },
                services: { type: 'array' },
                sku: { type: 'string' },
              },
            },
          },
        },
        subTotal: { type: 'number' },
      },
    },
  },
};
